import Box from '@mui/material/Box'
import ReactMarkdown from 'react-markdown'
import rehypeSanitize from 'rehype-sanitize'

// Course text is written in a small subset of markdown: paragraphs, bold,
// bullet and numbered lists, sub-headings and links. Anything else is
// dropped. Links only ever point at Open Government Licence sources (the
// content lint enforces that) and open in a new tab.
const ALLOWED = ['p', 'strong', 'ul', 'ol', 'li', 'h3', 'h4', 'a', 'br']

const Markdown = ({ children, sx }) => (
  <Box
    sx={{
      fontSize: '1.0625rem',
      lineHeight: 1.7,
      textAlign: 'left',
      '& p': { mt: 0, mb: 1.5 },
      '& p:last-child': { mb: 0 },
      '& ul, & ol': { mt: 0, mb: 1.5, pl: 3 },
      '& li': { mb: 0.75 },
      '& h3': { fontSize: '1.2rem', fontWeight: 700, mt: 2, mb: 1 },
      '& h4': { fontSize: '1.0625rem', fontWeight: 700, mt: 2, mb: 0.75 },
      '& a': { color: 'primary.main', textDecoration: 'underline' },
      ...sx,
    }}
  >
    <ReactMarkdown
      rehypePlugins={[rehypeSanitize]}
      allowedElements={ALLOWED}
      unwrapDisallowed
      components={{
        a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />,
      }}
    >
      {String(children ?? '')}
    </ReactMarkdown>
  </Box>
)

export default Markdown
